<div class="main">

    <div id="bean-wrapper">
        <img  (click)="playGame()"  src="assets/ico/bean-eater.svg" alt="bean eater"/>
    </div>
</div>